angular
    .module('vic.claim', ['claimVic.controller'])
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider
            .when('/claim-summary-vic', {
                templateUrl: 'module/claimVic/view/claim-summary-vic.html',
                controller: 'claimSummaryVicController'
            })
            .when('/claim-details-vic', {
                templateUrl: 'module/claimVic/view/claim-details-vic.html',
                controller: 'claimDetailsVicController'
            });

    }]);
